import { API, graphqlOperation } from "aws-amplify";
import * as mutations from "graphql/mutations";
import {
  createNativeResolution,
  deleteCampaignNativeResolutions,
  listNativeResolutions,
  updateNativeResolution,
} from "services/apiMiddleware";
import { replaceArrayItem } from "services/utils";
import _ from "lodash";
import { t } from "../../i18n";

const nativeResolutions = {
  state: {
    isLoading: false,
    error: null,
    items: [],
  },
  reducers: {
    loadStart: (state) => {
      return {
        ...state,
        isLoading: true,
      };
    },
    loadSuccess: (state, items) => {
      return {
        ...state,
        isLoading: false,
        error: null,
        items,
      };
    },
    createSuccess: (state, newItem) => {
      return {
        ...state,
        isLoading: false,
        error: null,
        items: [...state.items, newItem],
      };
    },
    updateSuccess: (state, updatedItem) => {
      return {
        ...state,
        isLoading: false,
        error: null,
        items: replaceArrayItem(state.items, (item) => item.id === updatedItem.id, updatedItem),
      };
    },
    deleteSuccess: (state, deletedId) => {
      return {
        ...state,
        isLoading: false,
        error: null,
        items: state.items.filter((item) => item.id !== deletedId),
      };
    },
    failure: (state, error) => {
      return {
        ...state,
        isLoading: false,
        error,
      };
    },
  },
  effects: (dispatch) => ({
    async load() {
      try {
        dispatch.nativeResolutions.loadStart();
        const { data, errorMessage } = await listNativeResolutions();
        dispatch.nativeResolutions.loadSuccess(data);
        if (errorMessage) console.warn(errorMessage);
      } catch (error) {
        console.error(error);
        dispatch.nativeResolutions.failure(t("native_resolutions_load_error", { ns: "common" }));
      }
    },
    async create(createProps) {
      try {
        dispatch.nativeResolutions.loadStart();
        const { data, errorMessage } = await createNativeResolution(createProps);
        dispatch.nativeResolutions.createSuccess(data);
        if (errorMessage) console.warn(errorMessage);
        return data;
      } catch (error) {
        dispatch.nativeResolutions.failure(t("native_resolutions_create_error", { ns: "common" }));
        throw error;
      }
    },
    async update(updateProps) {
      try {
        dispatch.nativeResolutions.loadStart();
        const { data, errorMessage } = await updateNativeResolution(updateProps);
        dispatch.nativeResolutions.updateSuccess(data);
        if (errorMessage) console.warn(errorMessage);
        return data;
      } catch (error) {
        dispatch.nativeResolutions.failure(t("native_resolutions_update_error", { ns: "common" }));
        throw error;
      }
    },
    async delete(nativeResolution) {
      try {
        dispatch.nativeResolutions.loadStart();

        // First, delete native resolution's items from CampaignNativeResolution join table
        const campaignNrsToDelete = _.map(nativeResolution.campaigns.items, "id");
        await deleteCampaignNativeResolutions(campaignNrsToDelete);

        // Then, delete the native resolution
        const result = await API.graphql(
          graphqlOperation(mutations.deleteNativeResolution, { input: { id: nativeResolution.id } })
        );
        const deletedId = result.data.deleteNativeResolution.id;
        dispatch.nativeResolutions.deleteSuccess(deletedId);
      } catch (error) {
        dispatch.nativeResolutions.failure(t("native_resolutions_delete_error", { ns: "common" }));
        throw error;
      }
    },
  }),
};

export default nativeResolutions;
